/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

const HANDLE_UPLOAD_DIALOG_CLICK = 'HANDLE_UPLOAD_DIALOG_CLICK';
const CLEAR_UPLOAD_BULLETIN_STORE = 'CLEAR_UPLOAD_BULLETIN_STORE';
const SERVICE_BULLETIN = 'SERVICE_BULLETIN';
const BULLETIN_INFORMATION_CHANGE = 'BULLETIN_INFORMATION_CHANGE';
const UPDATE_FILE_NAME = 'UPDATE_FILE_NAME';

const initialState = {
    data: {},
    uploadDialogOpen: false,
    isEdit: false,
    selectedPdf: undefined,
    fileName: ''
}

export const actionCreators = {
    handleUploadDialogClick: (isOpen: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: HANDLE_UPLOAD_DIALOG_CLICK, isOpen });
    },
    clearAll: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_UPLOAD_BULLETIN_STORE });
    },
    UpdateSelectedPdf: (selectedPdf: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: SERVICE_BULLETIN, selectedPdf });
    },
    handleBulletinInformationChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: BULLETIN_INFORMATION_CHANGE, event });
    },
    UpdateFileName: (fileName: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_NAME, fileName });
    }

}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case HANDLE_UPLOAD_DIALOG_CLICK:
            return {
                ...state,
                uploadDialogOpen: action.isOpen
            };
        case SERVICE_BULLETIN:
            return {
                ...state,
                selectedPdf: action.selectedPdf
            };
        case CLEAR_UPLOAD_BULLETIN_STORE:
            return initialState;
        case BULLETIN_INFORMATION_CHANGE:
            return {
                ...state,
                [action.event.target.name]: action.event.target.value
            };
        case UPDATE_FILE_NAME:
            return {
                ...state,
                fileName: action.fileName
            };
    }
    return state;
};
